import { prop_tax } from '@ratehub/mortgage-calculations';


export default function calculatePropertyTaxAmount({ propertyTax, location, homePrice }) {
    if (propertyTax) {
        return propertyTax / 12;
    }

    return location?.province?.code && homePrice
        ? Math.round(homePrice * prop_tax(location?.province?.code, location?.slug) / 12)
        : null;
}
